import { render, staticRenderFns } from "./OfertaDispComponent.vue?vue&type=template&id=4b7c0bfe&"
import script from "./OfertaDispComponent.vue?vue&type=script&lang=js&"
export * from "./OfertaDispComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports